export default {
  automatedResponses: [],
  automatedResponse: undefined,
};
